import { Link, useMatch } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
// import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import Logo from '../../src/asset/images/logo2.svg' 

const ContentProvider=(props)=>{
    // const match=useMatch("/about-us")
    // const { authState, authDispatch } = useContext(GlobalContext);

    const [state, setState] = useState([]);
    // henceforthApi.setToken(authState?.access_token);
  
    const initialiseData = async () => {
      try {
        let apiRes = await henceforthApi?.Policies.all(props.type);
       setState(  Array.isArray(apiRes) ? apiRes[0] : "")
        // setState(apiRes);
      } catch (error) { }
    };
    console.log(state)
    useEffect(() => {
      initialiseData();
    }, []);
return(
  <div className={`create-auction visible privacy-policy-page`}>
  <div className="container-fluid px-4">
    <div className="logo pt-4">
      <img src={Logo} alt='img'></img>
    </div>
    <div className="d-flex justify-content-between align-items-center py-3">
      <Link to={`/`}>
        {/* <img src={Logo} className="img-fluid" /> */}
      </Link>
      {/* <button className="btn btn-danger py-0 px-2">
        <i className="fa-solid fa-xmark" onClick={()=>window.history.back()}></i></button> */}
    </div>
    <div className="create-aution-card pages">
      <div className="page-header">
        <h3 className="text-center fw-bold mb-0">
          { state?.type ? state.type == "TERM_AND_CONDITION" ? "TERMS_AND_CONDITIONS".split("_").join(" "): state?.type.split("_").join(" ") : ""}
          </h3>
      </div>
      <div className="terms-of-service-box" >
          <p className="m-0 " dangerouslySetInnerHTML={{ __html: state?.description ? state?.description :"" }} ></p>
      </div>
    </div>
  </div>
</div >
)
}
export default ContentProvider